// Language Context - Dil yönetimi
import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const settings = JSON.parse(localStorage.getItem('kaan-ai-settings') || '{}');
      return settings.language || 'tr';
    } catch {
      return 'tr';
    }
  });

  // Dil değiştiğinde localStorage'ı güncelle
  useEffect(() => {
    try {
      const settings = JSON.parse(localStorage.getItem('kaan-ai-settings') || '{}');
      settings.language = language;
      localStorage.setItem('kaan-ai-settings', JSON.stringify(settings));
    } catch (e) {
      console.error('Failed to save language:', e);
    }
  }, [language]);

  // Çeviri fonksiyonu
  const t = (key, params = {}) => {
    return getTranslation(language, key, params);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
